<script lang="ts" setup>
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import type { AppMultiSelectSelectedPlaceholder } from 'libs/ui/src/lib/components/selects/models/multi.model';

import type { AppMultiSelectOption } from '@libs/ui';
import { AppMultiSelect } from '@libs/ui';
import { AmenitiesFilter } from '@libs/trip-planner-interfaces';

import { HotelFilter } from '../model/hotelFilters';
import type {
  HotelFilterAmenitiesUpdate,
  PossiblAmenitiesFilters,
} from '../model/hotelFilters';

const { t } = i18n.global;
interface HotelAmenitiesFiltersProps {
  options: AppMultiSelectOption<AmenitiesFilter>[];
  useTeleport?: boolean;
  selectedPlaceholderFormat?: AppMultiSelectSelectedPlaceholder;
  shouldShowClearButton?: boolean;
  isWrapperScrolling?: boolean;
}

const props = defineProps<HotelAmenitiesFiltersProps>();

interface HotelAmenitiesFiltersEmits {
  (
    eventName: 'amenity-option-selected',
    value: HotelFilterAmenitiesUpdate
  ): void;
  (eventName: 'clear-selection'): void;
}

const emit = defineEmits<HotelAmenitiesFiltersEmits>();

function getAmenityTypeForFilter(
  amenity: AmenitiesFilter
): PossiblAmenitiesFilters {
  switch (amenity) {
    case AmenitiesFilter.AirConditioned:
      return HotelFilter.AmenitiesAirConditioned;
    case AmenitiesFilter.Gym:
      return HotelFilter.AmenitiesGym;
    case AmenitiesFilter.Parking:
      return HotelFilter.AmenitiesParking;
    case AmenitiesFilter.Pool:
      return HotelFilter.AmenitiesPool;
    case AmenitiesFilter.Spa:
      return HotelFilter.AmenitiesSpa;
    case AmenitiesFilter.VehicleChargingStation:
      return HotelFilter.AmenitiesVehicleChargingStation;
    case AmenitiesFilter.Wifi:
      return HotelFilter.AmenitiesWifi;
  }
}

function onSelectOption(
  selectedOption: AppMultiSelectOption<AmenitiesFilter>
): void {
  emit('amenity-option-selected', {
    type: getAmenityTypeForFilter(selectedOption.id),
    value: !!selectedOption.selected,
  });
}
</script>

<template>
  <AppMultiSelect
    type="modern"
    :options="props.options"
    :use-teleport="props.useTeleport"
    :placeholder="t('filter.amenities.description')"
    :placeholder-selected="t('filter.amenities.description')"
    :selected-placeholder-format="props.selectedPlaceholderFormat"
    should-show-clear-button
    :is-wrapper-scrolling="props.isWrapperScrolling"
    dynamic-height
    @select-single="onSelectOption"
    @clear-selection="emit('clear-selection')"
  />
</template>
